export default __webpack_public_path__ + "static/media/NW0190.34I-38035_-22384_0.2d0f8a54.jpg";